import { useState, useEffect, useRef } from 'react';
import { FaBars, FaTimes, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { NavLink, useLocation } from 'react-router-dom';

const Navbar = () => {
  // Temporary debug version (not recommended for production)
  const [debugContent, setDebugContent] = useState(null);

  const [isOpen, setIsOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [mobileServicesOpen, setMobileServicesOpen] = useState(false);
  const dropdownRef = useRef(null);
  const location = useLocation();

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setServicesOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Close all menus when route changes
  useEffect(() => {
    setIsOpen(false);
    setServicesOpen(false);
    setMobileServicesOpen(false);
  }, [location]);

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

  const toggleServices = () => {
    setServicesOpen(!servicesOpen);
  };

  // // Close mobile menu immediately when a dropdown item is clicked
  // const handleMobileItemClick = () => {
  //   setIsOpen(false);
  //   setServicesOpen(false);
  // };

  const toggleMobileServices = () => {
    setMobileServicesOpen(!mobileServicesOpen);
  };

  // Check if current route is one of the services
  const isServiceActive = () => {
    return [
      '/botox',
      '/dermal-fillers',
      '/laser-therapy',
      '/chemical-peels'
    ].includes(location.pathname);
  };

  const handleRedirect = () => {
    // window.location.href = 'https://sunrisewebapp.vercel.app'; // open the external URL in the current tab

    // // window.open('https://example.com', '_blank'); // open the external URL in the other tab

    // // //Optionally, you can add a third argument, 'noopener noreferrer', to enhance security
    // //window.open('https://example.com', '_blank', 'noopener noreferrer');

    // //  noopener: prevents the new page from gaining a reference to the originating page. Without this, the new tab can access the original tab via window.opener.
    // //  noreferrer: also blocks the referer header from being sent, so the new page cannot see the originating page's URL in the HTTP request headers.
    // //Adding these options enhances security by ensuring that the new tab can't interact with the original page, which is especially important when linking to third-party or untrusted websites.
  };

  return (
    <nav className="bg-white shadow-lg border-b-2">

      {/* ========================================================================================= */}
      {/* Debug Content */}
      {/* ========================================================================================= */}
      {/* // Then somewhere in your Navbar component's return: */}
      {debugContent && (
        // <div className=" bg-white p-8 z-50">
        <div className="fixed inset-0 bg-white p-8 z-50">
          <button onClick={() => setDebugContent(null)}>Close</button>
          {debugContent}
        </div>
      )}

      {/* <div className="max-w-7xl mx-auto px-4"> */}
      <div className="w-full mx-auto px-2 md:px-20 text-sm md:text-base">
        <div className="flex justify-between items-center h-8">

          {/* Logo */}
          <div className="flex-shrink-0">
            <NavLink to="/">
              <div className="flex gap-1 md:gap-3 items-center relative">
                {/* <img src="/Images/BizAppsTrimmed.jpg" className="h-8 sm:h-9 md:h-12" alt="Flowbite React Logo"  */}
                {/* <img src="/Images/BizAppsTrimmed.jpg" className="absolute top-0 h-8 sm:h-9 md:h-12 z-50" alt="Logo" */}
                <img src="/BizAppsTrimmed.png" className="absolute top-0 h-8 sm:h-9 md:h-14 z-50" alt="Logo"
                  onDoubleClick={() => handleRedirect()}
                />
                <div className="ml-40 self-center whitespace-nowrap md:text-3xl leading-none font-poppins tracking-wide">
                  {/* Sunrise Dairy <span className=" font-thin hidden md:inline" >Pvt Ltd</span> */}
                  Smart Business Applications
                </div>
                {/* <div className="flex flex-col text-left justify-center">
                    <div className="whitespace-nowrap text-3xl leading-none font-semibold tracking-widest ">Sunrise</div>
                    <div className="whitespace-nowrap text-gray-700 hidden md:block text-sm md:text-base ">Diagnostic & Refrective Surgery Center</div>
                  </div> 
                  */}
              </div>

              {/* <div className="self-center whitespace-nowrap text-gray-700 md:hidden block text-sm md:text-base ">Diagnostic & Refrective Surgery Center</div> */}
              {/* <div className="text-left self-center whitespace-nowrap text-gray-700 md:hidden block text-sm md:text-base ">Diagnostic & Refrective Surgery Center</div> */}
              {/* </div> */}

            </NavLink>
          </div>

          {/* ============================================================ */}
          {/* Desktop Menu */}
          {/* ============================================================ */}
          {/* <div className="hidden md:flex items-center space-x-8"> */}
          <div className="hidden md:flex items-center ">
            <NavLink
              to="/"
              className={({ isActive }) =>
                `flex px-3 py-2 rounded-md font-medium ${isActive ? 'text-blue-600 font-semibold underline ' : 'text-gray-800 hover:text-blue-600'}`
              }
            >
              <img className="w-[22px] h-[22px] mr-1" src="/assets/Menu/HomePage.png" alt="Home" />
              Home
            </NavLink>

            {/* Desktop Services Dropdown */}
            <div className="relative" ref={dropdownRef}>
              <button
                // onClick={toggleServices}
                className={`flex px-3 py-2 rounded-md font-medium items-center ${isServiceActive() ? 'text-blue-600 font-semibold underline' : 'text-gray-800 hover:text-blue-600'
                  }`}
              >
                <img className="w-[22px] h-[22px] mr-1" src="/assets/Menu/Items.png" alt="Services" />
                Services
                {servicesOpen ? <FaChevronUp className="ml-1" /> : <FaChevronDown className="ml-1" />}
              </button>

              {servicesOpen && (
                <div className="absolute left-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-10 border border-gray-100">
                  {/* Desktop dropdown items */}
                  <NavLink
                    to="/botox"
                    // to="#"
                    // onClick={(e) => {
                    //   e.preventDefault();
                    //   setDebugContent(<div>Special Botox Treatment Should Fall Here</div>);
                    // }}
                    className={({ isActive }) =>
                      `block px-4 py-2 text-sm ${isActive ? 'bg-blue-50 text-blue-600 font-medium' : 'text-gray-700 hover:bg-blue-50 hover:text-blue-600'}`
                    }
                  >
                    Botox Treatments
                  </NavLink>
                  <NavLink
                    to="/dermal-fillers"
                    className={({ isActive }) =>
                      `block px-4 py-2 text-sm ${isActive ? 'bg-blue-50 text-blue-600 font-medium' : 'text-gray-700 hover:bg-blue-50 hover:text-blue-600'}`
                    }
                  >
                    Dermal Fillers
                  </NavLink>
                  <NavLink
                    to="/laser-therapy"
                    className={({ isActive }) =>
                      `block px-4 py-2 text-sm ${isActive ? 'bg-blue-50 text-blue-600 font-medium' : 'text-gray-700 hover:bg-blue-50 hover:text-blue-600'}`
                    }
                  >
                    Laser Therapy
                  </NavLink>
                  <NavLink
                    to="/chemical-peels"
                    className={({ isActive }) =>
                      `block px-4 py-2 text-sm ${isActive ? 'bg-blue-50 text-blue-600 font-medium' : 'text-gray-700 hover:bg-blue-50 hover:text-blue-600'}`
                    }
                  >
                    Chemical Peels
                  </NavLink>
                </div>
              )}
            </div>

            <NavLink
              to="/about"
              className={({ isActive }) =>
                `flex px-3 py-2 rounded-md font-medium ${isActive ? 'text-blue-600 font-semibold underline ' : 'text-gray-800 hover:text-blue-600'}`
              }
            >
              <img className="w-[22px] h-[22px] mr-1" src="/assets/Menu/Aboutus.png" alt="Home" />
              About Us
            </NavLink>
            <NavLink
              to="/contact"
              className={({ isActive }) =>
                `flex px-3 py-2 rounded-md font-medium ${isActive ? 'text-blue-600 font-semibold underline ' : 'text-gray-800 hover:text-blue-600'}`
              }
            >
              <img className="w-[22px] h-[22px] mr-1" src="/assets/Menu/Contactus.jpg" alt="Home" />
              Contact Us
            </NavLink>
          </div>

          {/* ..................................... */}
          {/* Mobile menu button */}
          {/* ..................................... */}
          <div className="md:hidden flex items-center">
            <button
              onClick={toggleNavbar}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-800 hover:text-blue-600 focus:outline-none"
            >
              {isOpen ? <FaTimes /> : <FaBars />}
            </button>
          </div>
        </div>
      </div>

      {/* ============================================================ */}
      {/* Mobile Menu  */}
      {/* ============================================================ */}
      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-white pb-3 px-4 border-t border-gray-200">
          <div className="flex flex-col space-y-1">
            {/* Mobile menu items */}
            <NavLink
              to="/"
              onClick={() => setIsOpen(false)}
              className={({ isActive }) =>
                `flex px-3 py-2 rounded-md font-medium ${isActive ? 'bg-blue-50 text-blue-600 font-semibold underline ' : 'text-gray-800 hover:bg-blue-50 hover:text-blue-600'}`
              }
            >
              <img className="w-[22px] h-[22px] mr-1" src="/assets/Menu/HomePage.png" alt="Home" />
              Home
            </NavLink>

            {/* Mobile Services Dropdown */}
            <div className="flex flex-col">
              <button
                // onClick={toggleMobileServices}
                className={`px-3 py-2 rounded-md font-medium flex justify-between items-center ${isServiceActive() ? 'bg-blue-50 text-blue-600 font-semibold underline ' : 'text-gray-800 hover:bg-blue-50 hover:text-blue-600'
                  }`}
              >
                <div className='flex'>
                  <img className="w-[22px] h-[22px] mr-1" src="/assets/Menu/Items.png" alt="Services" />
                  <span>Services</span>
                </div>
                {mobileServicesOpen ? <FaChevronUp /> : <FaChevronDown />}
              </button>

              {mobileServicesOpen && (
                <div className="pl-4 space-y-1 mt-1">
                  {/* Mobile dropdown items */}
                  <NavLink
                    to="/botox"
                    onClick={() => {
                      setIsOpen(false);
                      setMobileServicesOpen(false);
                    }} 
                    className={({ isActive }) =>
                      `block px-3 py-2 text-sm rounded-md ${isActive ? 'bg-blue-50 text-blue-600 font-medium' : 'text-gray-700 hover:bg-blue-50 hover:text-blue-600'}`
                    }
                  >
                    Botox Treatments
                  </NavLink>
                  <NavLink
                    to="/dermal-fillers"
                    onClick={() => {
                      setIsOpen(false);
                      setMobileServicesOpen(false);
                    }} 
                    className={({ isActive }) =>
                      `block px-3 py-2 text-sm rounded-md ${isActive ? 'bg-blue-50 text-blue-600 font-medium' : 'text-gray-700 hover:bg-blue-50 hover:text-blue-600'}`
                    }
                  >
                    Dermal Fillers
                  </NavLink>
                  <NavLink
                    to="/laser-therapy"
                    onClick={() => {
                      setIsOpen(false);
                      setMobileServicesOpen(false);
                    }} 
                    className={({ isActive }) =>
                      `block px-3 py-2 text-sm rounded-md ${isActive ? 'bg-blue-50 text-blue-600 font-medium' : 'text-gray-700 hover:bg-blue-50 hover:text-blue-600'}`
                    }
                  >
                    Laser Therapy
                  </NavLink>
                  <NavLink
                    to="/chemical-peels"
                    onClick={() => {
                      setIsOpen(false);
                      setMobileServicesOpen(false);
                    }} 
                    className={({ isActive }) =>
                      `block px-3 py-2 text-sm rounded-md ${isActive ? 'bg-blue-50 text-blue-600 font-medium' : 'text-gray-700 hover:bg-blue-50 hover:text-blue-600'}`
                    }
                  >
                    Chemical Peels
                  </NavLink>
                </div>
              )}
            </div>

            <NavLink
              to="/about"
              onClick={() => setIsOpen(false)}
              className={({ isActive }) =>
                `flex px-3 py-2 rounded-md font-medium ${isActive ? 'bg-blue-50 text-blue-600 font-semibold underline ' : 'text-gray-800 hover:bg-blue-50 hover:text-blue-600'}`
              }
            >
              <img className="w-[22px] h-[22px] mr-1" src="/assets/Menu/Aboutus.png" alt="Home" />
              About Us
            </NavLink>
            <NavLink
              to="/contact"
              onClick={() => setIsOpen(false)}
              className={({ isActive }) =>
                `flex px-3 py-2 rounded-md font-medium ${isActive ? 'bg-blue-50 text-blue-600 font-semibold underline ' : 'text-gray-800 hover:bg-blue-50 hover:text-blue-600'}`
              }
            >
              <img className="w-[22px] h-[22px] mr-1" src="/assets/Menu/Contactus.jpg" alt="Home" />
              Contact Us
            </NavLink>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;